<template>
  <div>
    <admin-sidebar></admin-sidebar>
    <section id="dashboard">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="title">
            <h2>Agjentet</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <ul class="management-btn">
              <li>
                <input
                  type="search"
                  placeholder="kerko"
                  :value="searchQuery"
                  @input="onChangeHandler"
                  v-on:keyup.enter="requestSearch"
                >
                <button type @click="requestSearch">
                  <i class="fas fa-search"></i>
                </button>
              </li>
              <li
                style="
                float: right;
                padding-top: 20px;
                font-weight: bold;
              "
              >
                <router-link tag="a" to="/admin/agents/requests">Menaxho kërkesat</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="white-background">
              <div class="tabcontent padding-0 tab-style">
                <table class="table table-responsive-md">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Emri dhe mbiemri</th>
                      <th>Email</th>
                      <th>Gjendja e targetit</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="agent in agentsList" :key="agent.id">
                      <th>{{ agent.id }}</th>
                      <th>{{ agent.full_name }}</th>
                      <th>{{ agent.email }}</th>
                      <th>{{ agent.referrals_count }} / 5</th>
                      <th>
                        <button id="agent-delete-button" class="bg-danger py-1 px-3 btn btn-danger text-capitalize" @click="deleteAgent(agent.id)">Fshij</button>
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <pagination
            :currentPage="currentPage"
            :totalPages="totalPages"
            @update-current-page="getCurrentPage"
        ></pagination>
      </div>
    </section>
  </div>
</template>

<style src="@/assets/admin/css/main.css">
</style>

<script>
import AdminSidebar from "@/components/admin/AdminSidebar";
import { mapGetters } from "vuex";
import Pagination from "@/views/Pagination.vue";

export default {
  name: "AdminAgents",
  components: {
    AdminSidebar: AdminSidebar,
    Pagination: Pagination
  },
  computed: {
    ...mapGetters({
      agentsList: "agents/agentsList",
      agentsCount: "agents/agentsCount",
      currentPage: "agents/currentPage",
      totalPages: "agents/totalPages",
      searchQuery: "agents/searchQuery",
      totalAgentsPerPage: "agents/totalAgentsPerPage"
    })
  },
  data() {
    return {
      searchQueryTimeOut: null
    }
  },
  methods: {
    deleteAgent(id) {
      let answer = confirm("A jeni i sigurte qe doni t'a fshini agjentin?!");
      if(answer === true){
        this.$store.dispatch("agents/deleteAgent", id);
      }
    },
    getCurrentPage(value) {
      this.$store.dispatch("agents/getCurrentPage", value);
    },
    getSearchQuery(e) {
      this.$store.dispatch("agents/getSearchQuery", e.target.value);
    },
    requestSearch() {
      this.$store.dispatch("agents/requestSearch");
    },
    onChangeHandler(e) {
      clearTimeout(this.searchQueryTimeOut);
      this.getSearchQuery(e);

      this.searchQueryTimeOut = setTimeout( () => {
        this.requestSearch();
      }, 500);
    }
  },
  beforeMount() {
    this.$store.dispatch("agents/getAgentsList");
  }
};
</script>
